(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(require('matter-js'));
  else root.SaguaroTrailRules = factory(root.Matter);
})(typeof globalThis !== 'undefined' ? globalThis : this, function (Matter) {
  'use strict';
  const VERSION = 5, MAX_HOLD = 2200, MAX_JUMPS = 160, EASY_SCORE_LIMIT = 300, MAX_SCORE = 1500;
  // 一次跳跃跨过的平台数 -> 得分。索引 0 是正常落到下一格，索引 4 代表跨 4 个及以上。
  const SKIP_SCORE = [10, 25, 45, 70, 100];
  const levels = {
    easy: { gapScale: .75, longThreshold: .80 - .08 * .6, narrowChance: .05 },
    normal: { gapScale: 1, longThreshold: .68, narrowChance: .18 }
  };
  function difficulty(score) { return score > EASY_SCORE_LIMIT ? 'normal' : 'easy'; }
  function random(seed) {
    let value = seed >>> 0;
    return function () {
      value += 0x6D2B79F5;
      let t = Math.imul(value ^ value >>> 15, 1 | value);
      t ^= t + Math.imul(t ^ t >>> 7, 61 | t);
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function platforms(seed, level = 'easy') {
    const settings = levels[level];
    if (!settings) throw new Error('Invalid difficulty');
    const rand = random(seed), list = [{ x: 130, y: 326, width: 140, kind: 0 }];
    for (let i = 1; i <= MAX_JUMPS + 1; i++) {
      const last = list[i - 1], roll = rand();
      const gap = (roll < .30 ? 100 + rand() * 60 : roll < settings.longThreshold ? 170 + rand() * 80 : 260 + rand() * 80) * settings.gapScale;
      const y = 326 + Math.max(-800, Math.min(800, last.y - 326 + (rand() - .45) * 120));
      let width = 68 + rand() * 72;
      const kind = Math.floor(rand() * 3);
      if (rand() < settings.narrowChance) width = 42 + rand() * 26;
      list.push({ x: last.x + gap, y, width, kind });
    }
    return list;
  }
  function normalTrack(state, track) {
    const normal = platforms(state.seed, 'normal');
    let anchorIndex = state.index;
    while (anchorIndex + 1 < track.length && track[anchorIndex + 1].x <= state.x + 900) anchorIndex++;
    const anchor = track[anchorIndex];
    const dx = anchor.x - normal[anchorIndex].x, dy = anchor.y - normal[anchorIndex].y;
    // Keep visible and immediately reachable platforms fixed; generate normal terrain beyond them.
    return track.map((platform, index) => index <= anchorIndex ? platform : {
      ...normal[index], x: normal[index].x + dx, y: normal[index].y + dy
    });
  }
  function initial(seed) { return { seed, index: 0, x: 130, score: 0, combo: 0, centerHits: 0, maxCombo: 0, jumps: 0, ended: false }; }
  function jump(state, hold, track = platforms(state.seed)) {
    if (state.ended || !Number.isInteger(hold) || hold < 0 || hold > MAX_HOLD || state.index >= MAX_JUMPS || state.jumps >= MAX_JUMPS) throw new Error('Invalid jump');
    const here = track[state.index];
    // Matter's gravity scale gives the reference's +0.32 velocity per 60 Hz step.
    const engine = Matter.Engine.create({ gravity: { x: 0, y: 1.152 }, enableSleeping: false });
    const body = Matter.Bodies.rectangle(state.x, here.y - 22, 6, 44, {
      frictionAir: 0, friction: 0, restitution: 0, inertia: Infinity, label: 'player'
    });
    const targets = track.map((platform, index) => ({ platform, index }))
      .filter(target => target.platform.x >= state.x - 150 && target.platform.x <= state.x + 750)
      .map(({ platform, index }) => {
      const halfWidth = platform.width / 2 * (platform.kind === 2 ? .70 : 1);
      const sensor = Matter.Bodies.rectangle(platform.x, platform.y + 8, halfWidth * 2, 28, { isStatic: true, isSensor: true });
      return { platform, index, sensor, halfWidth };
    });
    Matter.Composite.add(engine.world, [body, ...targets.map(target => target.sensor)]);
    const power = hold / MAX_HOLD;
    Matter.Body.setVelocity(body, { x: (60 + Math.pow(power, 1.6) * 390) / 62.5, y: -10 });
    let landing = null, previousFeet = here.y;
    // Resolve landings from the player's feet crossing a platform top. This keeps
    // the result stable at platform edges instead of depending on sensor timing.
    const checkLanding = () => {
      if (landing || body.velocity.y <= 0) return;
      const feet = body.position.y + 22;
      landing = targets.find(target => previousFeet <= target.platform.y + 2 && feet >= target.platform.y - 2 &&
        Math.abs(body.position.x - target.platform.x) <= target.halfWidth + 3) || null;
    };
    Matter.Events.on(engine, 'afterUpdate', checkLanding);
    const frames = [{ x: body.position.x, y: here.y }];
    for (let i = 0; i < 200; i++) {
      previousFeet = body.position.y + 22;
      if (body.velocity.y > 10 - .32) Matter.Body.setVelocity(body, { x: body.velocity.x, y: 10 - .32 });
      Matter.Engine.update(engine, 1000 / 60);
      frames.push({ x: body.position.x, y: landing ? landing.platform.y : body.position.y + 22 });
      if (landing || body.position.y + 22 > here.y + 600) break;
    }
    const end = frames[frames.length - 1];
    const landed = !!landing, forward = landed && landing.index > state.index;
    const perfect = forward && Math.abs(end.x - landing.platform.x) < 9;
    // 跨过的平台数：0 = 正常落到下一格，1 = 跳过一格，依此类推
    const skip = forward ? Math.max(0, landing.index - state.index - 1) : 0;
    const combo = forward ? perfect ? state.combo + 1 : 0 : state.combo;
    // 中心落点额外再 +10；跨平台按 SKIP_SCORE 计分（跨得越多奖励越高，4 个以上封顶）
    const gained = forward ? SKIP_SCORE[Math.min(skip, SKIP_SCORE.length - 1)] + (perfect ? 10 : 0) : 0;
    const index = landed ? landing.index : state.index, jumps = state.jumps + 1;
    const result = { ...state, x: end.x, index, jumps,
      score: Math.min(MAX_SCORE, state.score + gained), combo, centerHits: (state.centerHits || 0) + Number(perfect), maxCombo: Math.max(state.maxCombo || 0, combo), ended: !landed || state.score + gained >= MAX_SCORE || index >= MAX_JUMPS || jumps >= MAX_JUMPS };
    Matter.Events.off(engine);
    Matter.Composite.clear(engine.world, false);
    Matter.Engine.clear(engine);
    const levelChanged = landed && difficulty(state.score) !== difficulty(result.score);
    return { state: result, frames, landed, perfect, skip, gained, levelChanged,
      track: levelChanged ? normalTrack(result, track) : track };
  }
  function replay(seed, holds) {
    if (!Number.isInteger(seed) || !Array.isArray(holds) || holds.length > MAX_JUMPS) throw new Error('Invalid run');
    let state = initial(seed), elapsed = 0, jumpDurations = [];
    let track = platforms(seed);
    for (const hold of holds) {
      const result = jump(state, hold, track);
      elapsed += hold + (result.frames.length - 1) * 1000 / 60;
      jumpDurations.push((result.frames.length - 1) * 1000 / 60);
      state = result.state;
      track = result.track;
    }
    return { ...state, elapsed, jumpDurations };
  }
  return { VERSION, MAX_SCORE, MAX_HOLD, MAX_JUMPS, EASY_SCORE_LIMIT, difficulty, platforms, initial, jump, replay };
});
